import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatTableModule, MatTable } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { PropertySearchListDataSource } from './property-search-list-datasource';
import {PropertyService} from "../../../../domain/services/property/property.service";
import {RentalPropertyModel} from "../../../../domain/models/rental-property.model";
import {FilterTagContainerComponent} from "../../../../common/filter-tag-container/filter-tag-container.component";
import {EnrollmentTypeStrMap} from "../../../../domain/enums/enrollment-type.enum";
import {Icons} from "../../../../domain/enums/icons-enums";
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule, MatSuffix} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {StatusIndicatorComponent} from "../../../../common/status-indicator/status-indicator.component";
import {FrequencyPipe} from "../../../../common/frequency-pipe/frequency.pipe";
import {PropertyTypePipe} from "../../../../common/property-type-pipe/property-type.pipe";
import {RouterModule} from "@angular/router";
import {
  EnrollmentTypeIndicatorComponent
} from "../../../../common/enrollment-type-indicator/enrollment-type-indicator.component";
import {MatChipsModule} from "@angular/material/chips";
import {PropertySearchFilterComponent} from "../property-search-filter/property-search-filter.component";

@Component({
  selector: 'app-property-search-list',
  templateUrl: './property-search-list.component.html',
  styleUrl: './property-search-list.component.css',
  standalone: true,
  imports: [EnrollmentTypeIndicatorComponent, StatusIndicatorComponent, MatTableModule,
    FormsModule, MatIconModule, MatButtonModule, MatInputModule, MatPaginatorModule,
    MatSortModule, MatFormFieldModule, MatSelectModule, MatSuffix, CommonModule,
    MatChipsModule, RouterModule, StatusIndicatorComponent, FilterTagContainerComponent,
    FrequencyPipe, PropertyTypePipe, PropertySearchFilterComponent]
})
export class PropertySearchListComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<RentalPropertyModel>;
  @ViewChild(PropertySearchFilterComponent) filter!: PropertySearchFilterComponent;
  dataSource: PropertySearchListDataSource;
  protected readonly EnrollmentTypeStrMap = EnrollmentTypeStrMap;
  protected readonly icons = Icons;
  queryStatus: string = "";
  query = "";
  displayedColumns = ['id', 'rentalPropertyStreetAddress', 'frequency', 'type', 'status'];

  constructor(private readonly propertyService: PropertyService) {
    this.dataSource = new PropertySearchListDataSource(this.propertyService);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filter = this.filter;
    this.table.dataSource = this.dataSource;
  }

}
